// PROJECTS
export const projects = [
  {
    title: "Vakay!",
    subtitle: ["Next.js", "Firebase", "Auth0"],
    description: "Vakay! is the app in which users plan trips with many contributors like reunions or trips abroad with timelines, shared locations, photos, etc.",
    image: "./images/VakayUI.png",
    liveLink: "",
    gitLink: "https://github.com/gainesaurus/Vakay",
  },
  {
    title: "ifGift",
    subtitle: ["React", "Koa", "MongoDB"],
    description: "ifGift is the app to aid in the anxious act of gift-giving. Users create profiles with their gift preferences which other users can see to make more informed gift-giving choices. Users can also create gift-lists for their friends and family to compare with that person's posted Want Lists.",
    image: "./images/ifGiftUI.png",
    liveLink: "",
    gitLink: "https://github.com/gainesaurus/ifGift",
  },
  {
    title: "Subscriber",
    subtitle: ["React", "Typescript", "CSS"],
    description: "Subscriber is an app for tracking personal subscriptions and setting reminders for payment renewals or cancellations.",
    image: "./images/SubscriberUI.png",
    liveLink: "",
    gitLink: "https://github.com/gainesaurus/subscriber",
  },
  {
    title: "5e Monster Manual",
    subtitle: ["React", "dnd5eAPI", "GH-Pages"],
    description: "Using the DnD5e API, I have built a reference app for monsters from the Dungeons & Dragons Monster-Manual.",
    image: "./images/MonsterManual-UI.png",
    liveLink: "https://gainesaurus.github.io/monster-manual/",
    gitLink: "https://github.com/gainesaurus/monster-manual",
  },
  {
    title: "DMbattlr",
    subtitle: ["React", "Typescript", "MaterialUI"],
    description: "The upcoming app to help DMs track combat in the popular role-playing game, Dungeons & Dragons!",
    image: "./images/DMbattlr-UI.png",
    liveLink: "",
    gitLink: "https://github.com/gainesaurus/dmbattlr",
  },
  // {
  //   title: "SW-Samesies",
  //   subtitle: ["React", "SWAPI", "React Hooks"],
  //   description: "A job interview assessment had me build a quick app using the Star Wars API (swapi) to compare two characters. Built in a few hours.",
  //   image: "./images/SWmates-UI.png",
  //   liveLink: "",
  //   gitLink: "https://github.com/gainesaurus/sw-mates",
  // },
  {
    title: "This Portfolio Page!",
    subtitle: ["React", "CSS", "WCAG"],
    description: "The portfolio page for one heckuva nice developer",
    image: "./images/Portfolio-UI.png",
    liveLink: "https://gainesaur.netlify.app",
    gitLink: "https://github.com/gainesaurus/portfolio",
  },
  {
    title: "Emotional Wellbeing Lab",
    subtitle: ["React, Next.js, Wordpress"],
    description: "The website for the University of Western Australia's Emotional Wellbeing Lab.",
    image: "./images/ewb-lab-UI.png",
    link: "http://emotionalwellbeinglab.com.au/",
    gitLink: "https://github.com/gainesaurus/ewb-lab-site",
  },
  // {
  //   title: "Doctor Banjo",
  //   subtitle: ["React, Netlify"],
  //   description: "The homepage of Western Australia's Greatest Banjo Player",
  //   image: "",
  //   link: "",
  //   gitLink: "",
  // }
];


// SKILLS
export const skills = [
  "HTML",
  "CSS",
  "Javascript",
  "Typescript",
  "WCAG",
  "React",
  "React Hooks",
  "Next.js",
  "Material UI",
  "Firebase",
  "Auth0",
  "NodeJS",
  "JSON",
  "Express",
  "Koa",
  "MongoDB",
  "Mongoose",
  "MySQL",
  "Wordpress",
  "PHP",
  "Figma",
  "VS Code",
  "Github",
  "Postman",
  "Asana",
];


// TESTIMONIALS
export const testimonials = [
  {
    name: "Danielle Stroscher",
    title: "Software Developer",
    company: "Subscriber",
    quote: "\"Mike is a great developer! His easygoing yet hardworking, can-do attitude made me so grateful to be on the same team. I was always very impressed by his attention to detail and eye for front-end design. He has the ability to learn and implement anything handed to him and execute it very well. I hope to get the opportunity to work with him again!\"",
  },
  {
    name: "Gustavo Silva Navarro",
    title: "Software Engineer",
    company: "ifGift",
    quote: "\"I have had the pleasure to work with Mike in different projects. He is a team player who is always willing to help out, open to new ideas and approaches, and his positive attitude and willingness to pitch in make him a pleasure to work with. I have no doubt his skills would benefit any company!\"",
  },
  // {
  //   name: "Anonymous",
  //   title: "Undergraduate Student",
  //   company: "UCSD",
  //   quote: "\"Best instructor ever. So friendly and patient, and I really enjoyed his classes.\"",
  // },
  // {
  //   name: "Anonymous",
  //   title: "Undergraduate Student",
  //   company: "UCSD",
  //   quote: "\"AMAZING MAN 10/10!\"",
  // },
];
